import React from "react";
import styles from "./style.module.scss";
import { useTranslation } from "react-i18next";

type ComparisonFeature = {
	title: string;
	humanizeAI: string;
	gptZero: string;
	undetectableAI: string;
	saplingAI: string;
};

type ComparisonData = {
	title: string;
	subtitle: string;
	features: ComparisonFeature[];
};

export const ComparisonTableSection: React.FC = () => {
	const { t } = useTranslation();
	const data = t("comparisonTableSection", { returnObjects: true }) as ComparisonData;

	if (typeof data !== "object" || !data || !data.features) {
		return null;
	}

	const renderResult = (text: string, isHumanizeAI: boolean = false) => {
		const getIcon = (text: string) => {
			if (text.includes("✔")) return "checkmark";
			if (text.includes("✗")) return "cross";
			if (text.includes("⚠")) return "warning";
			return "";
		};

		const iconClass = getIcon(text);
		const displayText = text.replace(/[✔✗⚠]/g, "").trim();

		return (
			<span>
				{iconClass && (
					<span className={styles[iconClass]}>
						{text.includes("✔") && "✔"}
						{text.includes("✗") && "✗"}
						{text.includes("⚠") && "⚠"}
					</span>
				)}
				{displayText}
			</span>
		);
	};

	return (
		<div className={styles.ShadowsReference}>
			<div className={`${styles.ShadowsReference__content} app-container`}>
				<div className={styles.ShadowsReference__leftPart}>
					<h1 className={styles.ShadowsReference__subTitle}>{data.title}</h1>
					<p className={styles.ShadowsReference__paragraph}>{data.subtitle}</p>
					<div className={styles.ShadowsReference__table}>
						<div className={styles.ShadowsReference__tableHeader}>
							<div className={styles.ShadowsReference__headerCell}>Feature / Tool</div>
							<div className={styles.ShadowsReference__headerCell}>HumanizeAI</div>
							<div className={styles.ShadowsReference__headerCell}>GPTZero Bypass Tools</div>
							<div className={styles.ShadowsReference__headerCell}>Undetectable AI</div>
							<div className={styles.ShadowsReference__headerCell}>Sapling AI Humanizer</div>
						</div>
						{data.features.map((feature: ComparisonFeature, index: number) => (
							<div key={index} className={styles.ShadowsReference__tableRow}>
								<div className={styles.ShadowsReference__featureCell}>{feature.title}</div>
								<div
									className={`${styles.ShadowsReference__resultCell} ${styles.ShadowsReference__resultCell_humanizeAI}`}
								>
									{renderResult(feature.humanizeAI, true)}
								</div>
								<div className={styles.ShadowsReference__resultCell}>
									{renderResult(feature.gptZero)}
								</div>
								<div className={styles.ShadowsReference__resultCell}>
									{renderResult(feature.undetectableAI)}
								</div>
								<div className={styles.ShadowsReference__resultCell}>
									{renderResult(feature.saplingAI)}
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};
